class MobileMenu extends HTMLElement {
  constructor() {
    super();

    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.drawer = this.querySelector("[data-mobile-menu-drawer]");
    this.summary.addEventListener("click", (e) => {
      e.preventDefault();
      this._toggle();
    });
    this.closeButton = this.querySelector("[data-close-mobile-drawer]");
    this.closeButton.addEventListener("click", () => this._close());
    this.searchButton = this.querySelector("[data-search-trigger]");
    this.searchButton?.addEventListener("click", () => {
      this._close();
      document.dispatchEvent(new CustomEvent("mobile-search:open"));
    });

    this.addEventListener("mobile-submenu:close", () => {
      window.trapFocus(this.drawer);
    });

    this.closeEsc = (e) => {
      if (
        e.key === "Escape" &&
        this.classList.contains("open") &&
        !this.querySelector(".mobile-menu__main-mega-menu.open")
      ) {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);

    this.handleResize = () => {
      if (!this._isMobile && this.details.open) {
        this._forceClose();
      }

      this._setMaxHeightVariable();
    };

    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    window.removeEventListener("resize", this.handleResize);
  }

  _toggle() {
    this.details.open ? this._close() : this._open();
  }

  _forceClose() {
    this.classList.remove("open");
    this.details.open = false;
    window.closeMobileMenuFullDimmer(this);
    window.removeTrapFocus(this.summary, this.drawer);
    window.unlockScroll(this);
    this.removeEventListener("transitionend", this.onEnd);
  }

  _open() {
    this.details.open = true;
    window.requestAnimationFrame(() => {
      this.classList.add("open");
      this.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));
      window.lockScroll(this);
      window.openMobileMenuFullDimmer(this);
      // this.querySelector(".mobile-search__query-input").focus();
      // this.style.setProperty(
      //   "--mobile-menu-top",
      //   `${this.closest(".header").getBoundingClientRect().bottom}px`,
      // );
      this._setMaxHeightVariable();
    });
    window.trapFocus(this.drawer, this.closeButton);
  }

  _close() {
    if (!this.classList.contains("open")) return;

    this.classList.remove("open");
    this.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));

    const onEnd = (e) => {
      if (!("mobileMenuDrawer" in e.target.dataset)) return;

      this.removeEventListener("transitionend", onEnd);

      if (this.classList.contains("open")) return;
      this.details.open = false;
      window.removeTrapFocus(this.summary, this.drawer);
      window.unlockScroll(this);
      window.closeMobileMenuFullDimmer(this);
      this.dispatchEvent(
        new CustomEvent("mobile-menu:closed", { bubbles: true }),
      );
    };
    this.addEventListener("transitionend", onEnd);
  }

  _setMaxHeightVariable() {
    const container = this.querySelector(".header__mobile-menu-content");
    const { height } = container.getBoundingClientRect();

    // Need to account for out of flow header
    const containerHeader = this.querySelector("[data-mobile-menu-header]");
    const headerHeight = containerHeader.getBoundingClientRect().height;

    this.style.setProperty(
      "--mobile-menu-max-content-height",
      `${height - headerHeight}px`,
    );
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }
}

if (!customElements.get("mobile-menu")) {
  customElements.define("mobile-menu", MobileMenu);
}
